module.exports = {
    publicPath: process.env.NODE_ENV === 'development' ? '/v2-dev/' : '/v2/',
    devServer: {
        host: '0.0.0.0',
        client: {
            webSocketURL: 'ws://' + process.env.HOST_PORTAINER + ':' + process.env.PANEL_LEGACY_PORT +'/ws',
            overlay: false, // <- isso desativa os overlays de erro e warning
        },
        port: process.env.VUE_APP_DEV_PORT || 8080,
        hot: true,
    },
    outputDir: process.env.NODE_ENV === 'development' ? 'v2' : 'dist',
    chainWebpack: config => {
        // Null Loader
        config.optimization.minimize(false); // Desativa minificação no modo dev
        config.module
          .rule('null-loader')
          .test(/\.md$/)
          .use('null-loader')
            .loader('null-loader')
            .end()
    },
    lintOnSave: process.env.NODE_ENV === 'development'
}